export default "__VITE_PUBLIC_ASSET__10604938__"